"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_CONSOLE_ROLES = exports.DOMAIN_ADMIN_ROLES = void 0;
/** CloudPods / console role names (single source; fix typos like ai_edtior here only). */
exports.DOMAIN_ADMIN_ROLES = ['admin', 'domainadmin'];
exports.AI_CONSOLE_ROLES = [
    'admin',
    'domainadmin',
    'project_owner',
    'domain_editor',
    'project_editor',
    'ai_admin',
    'ai_editor',
    'ai_viewer',
];
